import { message } from 'antd';
import React from 'react'
import { useMutation, useQueryClient } from 'react-query';
import sliderApi from '../../../../api/sliderApi';
import SliderList from '../../../../components/SliderList';
import PageWrap from '../../../../layout/PageWrap';
import { messages } from '../../../../utils/messages';

const SliderWhyAI = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(sliderApi.deleteWhyAISlider, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.deleteSuccess);
        queryClient.invalidateQueries("whyai-slider");
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  return (
    <PageWrap
      title="Slider Why AI"
      content={
        <SliderList
          formdata={true}
          headContent="Slider Why AI"
          handleRemove={(e) => mutation.mutate(e)}
          keyQuery="whyai-slider"
          link="/slider/why-ai"
          query={sliderApi.getWhyAISlider}
          action={useMutation(sliderApi.editWhyAISlider, {
            onSuccess: (data: any) => {
              if (data.statusCode === 200) {
                message.success(messages.updateSuccess);
                queryClient.invalidateQueries("whyai-slider");
              } else {
                message.error(data?.data?.message ?? messages.error);
              }
            },
            onError: (err: any) => {
              message.error(err?.data?.message ?? messages.error);
            },
          })}
          column={[
            {
              title: "Link",
              dataIndex: "url",
              width: "40%",
              key: "url",
              render: (record: string) => {
                return (
                  <a target="_blank" href={record} rel="noreferrer">
                    {record}
                  </a>
                );
              },
            },
            {
              title: "Hình ảnh",
              dataIndex: "photo",
              width: "20%",
              key: "photo",
              className: "td-slider-picture",
              render: (record: string) => {
                return (
                  <img
                    src={`${process.env.REACT_APP_DOMAIN}${record}`}
                    alt=""
                    className="slider-picture"
                  ></img>
                );
              },
            },
          ]}
        />
      }
    />
  );
}

export default SliderWhyAI